import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "footer-container row" }
const _hoisted_3 = { class: "col-md-12 row ms-0 me-0 ps-0 pe-0 d-flex justify-content-between" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-6 mt-3 ps-1 pe-2 d-flex"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "footer-content" }, "© Powered By Secure365 Nextgen Solutions Sdn Bhd", -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  class: "footer-content",
  style: {"color":"darkgrey"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollTop = _resolveComponent("ScrollTop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.hideCompany ? '' : 'footer')
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (!_ctx.hideCompany)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.hideCompany ? 'col-md-12' : 'col-md-6', "mt-3 ps-1 pe-2 d-flex justify-content-end"])
            }, [
              _createElementVNode("span", _hoisted_7, _toDisplayString("Version " + _ctx.version + " @ " + _ctx.date), 1)
            ], 2)
          ])
        ])
      ])
    ], 2),
    _createVNode(_component_ScrollTop, {
      target: "window",
      threshold: 80,
      icon: "pi pi-arrow-up"
    })
  ], 64))
}